module.exports = __webpack_public_path__ + "static/media/cut.0881b447.jpg";